import React from "react";
import { connect } from "react-redux";
import { Dialog, Button } from "ui-components";

import { selectRisk, toggleDialog } from "@workerhome/components/App/actions";
import {
  RiskWarningDialogWrapper,
  RiskWarningDialogHeader,
  RiskWarningDialogContent,
  RiskWarningDialogDescription,
  RiskWarningDialogText,
  RiskWarningDialogButtons
} from "./styled";

const RiskWarningDialog = ({
  isShown,
  sectionTitle,
  children,
  dialog,
  stepsMeta,
  toggleDialog,
  selectRisk
}) => {
  // Render the risk warning dialog buttons
  const renderButtons = () => {
    // Handle risk warning dialog button clicks
    const onClick = isCancel => {
      // Cancel the weapons risk selection if indicated
      if (isCancel && dialog.key === "weapons") {
        selectRisk(null, stepsMeta.activeSubStep, dialog.riskIdx);
      }

      // Hide the risk warning dialog
      toggleDialog("RiskWarning", false);
    };

    // Render the buttons conditionally
    switch (dialog.key) {
      case "weapons":
        return [
          <Button key="cancel" secondary medium onClick={() => onClick(true)}>
            Cancel
          </Button>,
          <Button key="continue" medium onClick={() => onClick()}>
            Continue with Caution
          </Button>
        ];
      default:
        return (
          <Button key="close" medium onClick={() => onClick()}>
            Close
          </Button>
        );
    }
  };

  const dialogSizes = {
    tabletMax: "576px",
    desktopMax: "576px",
    largeMax: "576px"
  };

  return (
    <Dialog display={isShown} sizes={dialogSizes}>
      <RiskWarningDialogWrapper>
        <RiskWarningDialogHeader>
          {sectionTitle} - {dialog.title}
        </RiskWarningDialogHeader>
        <RiskWarningDialogContent>
          <RiskWarningDialogDescription>
            {dialog.description}
          </RiskWarningDialogDescription>
          <RiskWarningDialogText>
            {dialog.content}
          </RiskWarningDialogText>
          <RiskWarningDialogButtons>
            {renderButtons()}
          </RiskWarningDialogButtons>
        </RiskWarningDialogContent>
      </RiskWarningDialogWrapper>
    </Dialog>
  );
};

const mapStateToProps = state => {
  return {
    sectionTitle: state.workerHome.app.title,
    isShown: state.workerHome.app.ui.isRiskWarningDialogShown,
    stepsMeta: state.workerHome.sidebar.stepsMeta
  };
};

const mapDispatchToProps = dispatch => {
  return {
    selectRisk: (selectedValue, subSectionIdx, riskIdx) =>
      dispatch(selectRisk(selectedValue, subSectionIdx, riskIdx)),
    toggleDialog: (dialog, isShown) => dispatch(toggleDialog(dialog, isShown))
  };
};

const RiskWarningDialogContainer = connect(mapStateToProps, mapDispatchToProps)(
  RiskWarningDialog
);
export default RiskWarningDialogContainer;



// WEBPACK FOOTER //
// ./src/workerhome/components/Dialogs/RiskWarningDialog/RiskWarningDialogContainer.jsx